import * as React from 'react';
import { Form, DatePickerRange, TextInput, CustomSubmitButton, Select, CustomSubmitButtonType, ClearFormButton } from "soprasteria-ui-library";
import { useAuth } from '../../../App';
import { IRiskPotReportPreAssessmentSearchParams } from '../../../models/IRiskPotReport';
import { CareProviderDropdown } from '../../CareProviderDropdown/CareProviderDropdown';
import { ICareProvider } from '../../../models/ICareProvider';
import { RiskPotReportPreAssessmentSearchApi } from '../../../api/RiskPotReportPreAssessmentSearchApi';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

interface IRiskPotReportPreAssessmentSearchForm {
    searchPreAssessments: (data: IRiskPotReportPreAssessmentSearchParams) => void;
    preSetSearchParams?: IRiskPotReportPreAssessmentSearchParams;
    searchPreAssessmentsToExcel: (data: IRiskPotReportPreAssessmentSearchParams) => void;
}

export const RiskPotReportPreAssessmentSearchForm: React.FunctionComponent<IRiskPotReportPreAssessmentSearchForm> = ({ searchPreAssessments, preSetSearchParams, searchPreAssessmentsToExcel }) => {
    const auth = useAuth();
    const api = new RiskPotReportPreAssessmentSearchApi(auth);
    const [careProviders, setCareProviders] = React.useState<ICareProvider[]>();
    const [statuses, setStatuses] = React.useState<IListItem[]>();

    React.useEffect(() => {
        getCareProviders()
        getStatuses();
    }, [])

    const getCareProviders = () => {
        api.getCareProviders((data) => setCareProviders(data));
    }

    const getStatuses = () => {
        api.getRiskPotPreAssessmentStatuses((statuses) => {
            const newStatuses = statuses.map<IListItem>((status) => { return { text: status.description, value: status.riskPotPreAssessmentStatusId.toString() } });
            setStatuses(newStatuses);
        })
    }

    const getCareProviderDefaultValue = () => {
        if (careProviders?.length === 1) {
            return careProviders[0].careProviderId.toString();
        }
        if (preSetSearchParams?.careProviderId) {
            return preSetSearchParams?.careProviderId.toString();
        }

        return undefined;
    }

    return (
        <section>
            <Form>
                <div className="row">
                    <div className="col-6">
                        <DatePickerRange label="Datum" name="createdDateFrom" nameSecondary="createdDateTo" inlineLabel
                            value={preSetSearchParams?.createdDateFrom ? new Date(preSetSearchParams.createdDateFrom) : undefined}
                            valueSecondary={preSetSearchParams?.createdDateTo ? new Date(preSetSearchParams.createdDateTo) : undefined} />
                        <TextInput name="riskPotReportNumber" label="Ärendenummer" inlineLabel defaultValue={preSetSearchParams?.riskPotReportNumber} />
                        <TextInput name="patientPersonalSecurityId" label="Personnummer" inlineLabel defaultValue={preSetSearchParams?.patientPersonalSecurityId} />
                    </div>
                    <div className="col-6">
                        <CareProviderDropdown
                            careProviders={careProviders}
                            name="careProviderId"
                            defaultValue={getCareProviderDefaultValue()}
                            isLoading={careProviders === undefined} />
                        <Select name="statusId" inlineLabel label="Status" options={statuses ?? []} isLoading={statuses === undefined} selectedValue={preSetSearchParams?.statusId?.toString()} placeholder="Välj status" isClearable />
                    </div>
                    <div className="col-12">
                        <div className="text-right panel">
                            <span className="d-none">
                                <CustomSubmitButton onButtonSubmit={searchPreAssessments}>Sök</CustomSubmitButton>
                            </span>
                            <ClearFormButton />
                            <CustomSubmitButton buttonType={CustomSubmitButtonType.alternative} onButtonSubmit={searchPreAssessmentsToExcel}><FontAwesomeIcon icon={faFileExcel} /> Exportera till Excel</CustomSubmitButton>
                            <CustomSubmitButton onButtonSubmit={searchPreAssessments}>Sök</CustomSubmitButton>
                        </div>
                    </div>
                </div>
            </Form>
        </section>
    )
}